<i18n>
  {
    "fr": {
      "ConfiguratorEditorGraphismTab": {
        "title": "Personnalisation"
      }
    }
  }
  </i18n>

<template>
  <div :class="blockClasses">
    <h2 v-if="isDocked" :class="`${BLOCK_SELECTOR}__title`">
      {{ $t('ConfiguratorEditorGraphismTab.title') }}
    </h2>
    <ConfiguratorGlassSettingsGraduation
      v-if="isGraduationEditable"
      :class="`${BLOCK_SELECTOR}__glass-settings-graduation`"
    />
    <ConfiguratorZoneList
      ref="zoneList"
      :items="customizationsGroupedByGroup"
    />
  </div>
</template>

<script>
import {
  ConfiguratorGetters,
  mapGetters as mapConfiguratorGetters,
} from '../../store/modules/configurator';
import ConfiguratorZoneList from './ConfiguratorZoneList';
import ConfiguratorGlassSettingsGraduation from './GlassSettings/ConfiguratorGlassSettingsGraduation.vue';

export default {
  name: 'ConfiguratorEditorGraphismTab',
  components: { ConfiguratorZoneList, ConfiguratorGlassSettingsGraduation },
  props: {
    isDocked: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      BLOCK_SELECTOR: 'configurator-editor-graphism-tab',
    };
  },
  computed: {
    blockClasses() {
      return [
        {
          [this.BLOCK_SELECTOR]: true,
          [`${this.BLOCK_SELECTOR}--is-docked`]: this.isDocked,
        },
      ];
    },
    ...mapConfiguratorGetters({
      customizationsGroupedByGroup:
        ConfiguratorGetters.GET_ZONE_CUSTOMIZATIONS_GROUPED_BY_GROUP,
      activeProductVariant: ConfiguratorGetters.GET_ACTIVE_PRODUCT_VARIANT,
      isGraduationEditable: ConfiguratorGetters.IS_GRADUATION_EDITABLE,
    }),
  },
  methods: {
    /**
     * Focuses the first customization input field.
     * Proxy method to ConfiguratorZoneList.focusFirstField().
     * @returns {boolean}
     */
    focusFirstField() {
      // The focus is only active on desktop mode to prevent mobile keyboard from opening
      if (this.isDocked) {
        return this.$refs.zoneList?.focusFirstField() ?? false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.configurator-editor-graphism-tab {
  padding: 1rem 0.625rem 2rem;

  &--is-docked {
    background-color: $color-white;
    border-radius: 1.5625rem;
    padding: 1.875rem 2.1875rem;
    margin-bottom: 1rem;
  }

  &__title {
    font-size: 1.25rem;
    font-weight: 900;
    text-transform: uppercase;
    color: $color-blue-persian;
    font-family: $font-big-shoulders;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 1.4375rem;

    &::before {
      @extend %icon;
      @extend %icon--customization;

      display: inline;
      color: $color-blue-persian;
      font-size: 32px;
    }
  }

  &__glass-settings-graduation {
    margin-bottom: 1.4375rem;
  }
}
</style>
